import { useI18n } from "@/lib/i18n";

const LINKS = {
  de: "https://www.qualitaetsuedtirol.com/de/produkte/honig.html",
  it: "https://www.qualitaetsuedtirol.com/it/prodotti/miele.html",
  en: "https://www.qualitaetsuedtirol.com/en/products/honey.html",
};

const ALT = {
  de: "Qualitätszeichen Südtirol",
  it: "Marchio di Qualità Alto Adige",
  en: "South Tyrol Quality Mark",
};

const HEIGHTS = { sm: "h-10", md: "h-14", lg: "h-20" };

const LAJEN_LINKS = {
  de: "https://www.lajen.info/de",
  it: "https://www.lajen.info/it",
  en: "https://www.lajen.info/en/holidays-dolomites",
};

const SUEDTIROL_LINKS = {
  de: "https://www.suedtirol.info/de/de/regionale-produkte/produkte-mit-qualitaetszeichen",
  it: "https://www.suedtirol.info/it/it/prodotti-locali/prodotti-marchio-qualita",
  en: "https://www.suedtirol.info/en/en/regional-products/products-with-the-seal-of-quality",
};

export const QualitaetLogo = ({ size = "md", testid = "qualitaet-logo" }) => {
  const { lang } = useI18n();
  const l = LINKS[lang] ? lang : "de";
  return (
    <a
      href={LINKS[l]}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      aria-label={ALT[l]}
      className="inline-block hover:opacity-80 transition-opacity"
    >
      <img src={`/images/qualitaet/logo-${l}.svg`} alt={ALT[l]} className={`${HEIGHTS[size]} w-auto`} />
    </a>
  );
};

export const LajenLogo = ({ size = "md", testid = "lajen-logo" }) => {
  const { lang } = useI18n();
  const l = LAJEN_LINKS[lang] ? lang : "de";
  const badge = { sm: "h-16 w-16 p-2", md: "h-20 w-20 p-2.5", lg: "h-24 w-24 p-3" };
  return (
    <a
      href={LAJEN_LINKS[l]}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      aria-label="Lajen · Laion"
      className={`inline-flex items-center justify-center bg-white rounded-full hover:opacity-90 transition-opacity ${badge[size]}`}
    >
      <img src="/images/partner/lajen-logo.png" alt="Lajen · Laion — Dolomiten" className="max-h-full max-w-full w-auto h-auto object-contain" />
    </a>
  );
};

export const SuedtirolLogo = ({ size = "md", testid = "suedtirol-logo" }) => {
  const { lang } = useI18n();
  const l = SUEDTIROL_LINKS[lang] ? lang : "de";
  return (
    <a
      href={SUEDTIROL_LINKS[l]}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      aria-label="Südtirol"
      className="inline-block hover:opacity-90 transition-opacity"
    >
      <img src="/images/partner/suedtirol-logo.svg" alt="Südtirol — Produkte mit Qualitätszeichen" className={`${HEIGHTS[size]} w-auto`} />
    </a>
  );
};
